import { CardContent, Stack } from "@mui/material";
import { Card, CbhIcon, Text } from "@src/appV2/redesign/system/ui-components";

interface TimesheetVerificationCardProps {
  verificationMessage: string;
}

export function TimesheetVerificationCard(props: TimesheetVerificationCardProps) {
  const { verificationMessage } = props;

  return (
    <Card>
      <CardContent sx={{ padding: 7 }}>
        <Stack direction="row" spacing={4} alignItems="flex-start">
          <CbhIcon type="document" size="large" />
          <Stack spacing={3}>
            <Text bold variant="body1">
              Verify your timesheet
            </Text>
            <Text variant="body2" sx={{ color: (theme) => theme.palette.text.secondary }}>
              {verificationMessage}
            </Text>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}
